'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { usePathname } from 'next/navigation';
import { Text } from '../../atoms/Text/Text';
import { StyledNavigationItem, StyledNavigationLink } from './NavigationItem.styles';
const normalizePath = (path)=>path === '/' ? '/' : path.replace(/\/+$/, '');
export const NavigationItem = ({ href, text })=>{
    const pathname = usePathname();
    return /*#__PURE__*/ _jsx(StyledNavigationItem, {
        children: /*#__PURE__*/ _jsx(StyledNavigationLink, {
            href: href,
            tabIndex: href ? undefined : 0,
            children: /*#__PURE__*/ _jsx(Text, {
                isBold: normalizePath(pathname) === normalizePath(href),
                size: "Xs",
                children: text
            })
        })
    });
};

//# sourceMappingURL=NavigationItem.js.map